/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMicrosConsulting = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 2v4h4v12h-4v4H2V2zm-2 2H4v16h12zm-5.646 1.646 3.707 3.708-3.707 3.707-1.415-1.415L10.584 10H10a3 3 0 1 0 2.995 3.176L13 13h2a5 5 0 1 1-5.217-4.995l.098-.003-.942-.941zM20 8h-2v8h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMicrosConsulting as MicrosConsulting };
